import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Marketing from "@/pages/Marketing";
import ServiceDetail from "@/pages/ServiceDetail";
import Location from "@/pages/Location";
import BrandPage from "@/pages/BrandPage";
import CityService from "@/pages/CityService";
import ComboDispatcher from "@/pages/ComboDispatcher";
import Book from "@/pages/Book";
import Track from "@/pages/Track";
import Sitemap from "@/pages/Sitemap";
import CrmEntry from "@/pages/CrmEntry";
import DispatchEntry from "@/pages/DispatchEntry";
import TechEntry from "@/pages/TechEntry";
import PaySuccess from "@/pages/PaySuccess";
import PayCancel from "@/pages/PayCancel";
import Pay from "@/pages/Pay";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster richColors position="top-center" closeButton />
      <Routes>
        <Route path="/" element={<Marketing />} />
        <Route path="/services/:appliance" element={<ServiceDetail />} />
        <Route path="/locations/:slug" element={<Location />} />
        <Route path="/brands/:slug" element={<BrandPage />} />
        <Route path="/book" element={<Book />} />
        <Route path="/track" element={<Track />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/crm" element={<CrmEntry />} />
        <Route path="/dispatch" element={<DispatchEntry />} />
        <Route path="/tech" element={<TechEntry />} />
        <Route path="/pay/success" element={<PaySuccess />} />
        <Route path="/pay/cancel" element={<PayCancel />} />
        <Route path="/pay/:id" element={<Pay />} />
        {/* Long-tail combo SEO pages: must come after all specific routes */}
        <Route path="/:combo" element={<ComboDispatcher />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
